/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createInboundVoiceCase} from '../api'

export const useMutationCreateInboundVoiceCase = createReactQueryMutationHook('createInboundVoiceCase', createInboundVoiceCase)
